export default __webpack_public_path__ + "static/camera-podium-min-7a8bc93faf4e104bbcdf0edd2d715900.png";